var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyTasks = function SvgEmptyTasks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.2152 24.5273H7.78476C4.84453 24.5273 2.4375 26.9344 2.4375 29.8746V65.2031C2.4375 68.1434 4.84453 70.5504 7.78476 70.5504H70.2305C73.1707 70.5504 75.5777 68.1434 75.5777 65.2031V29.8746C75.5625 26.9344 73.1555 24.5273 70.2152 24.5273V24.5273ZM66.1172 20.2617H11.8828C10.7098 20.2617 9.75 19.302 9.75 18.1289C9.75 16.9559 10.7098 15.9961 11.8828 15.9961H66.1172C67.2902 15.9961 68.25 16.9559 68.25 18.1289C68.25 19.302 67.2902 20.2617 66.1172 20.2617ZM61.425 11.7305H16.575C15.5086 11.7305 14.625 10.8469 14.625 9.78047V9.41484C14.625 8.34844 15.5086 7.46484 16.575 7.46484H61.425C62.4914 7.46484 63.375 8.34844 63.375 9.41484V9.78047C63.375 10.8469 62.4914 11.7305 61.425 11.7305Z",
    fill: "#9194A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29 40H49V44H29V40ZM46 45H32H31H30V56C30 57.104 30.896 58 32 58H46C47.104 58 48 57.104 48 56V45H47H46ZM43 51H35V49H43V51Z",
    fill: "#9194A9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyTasks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyTasks.fb0799a7.svg";
export { ForwardRef as ReactComponent };